<div #floorplan class="floorplan">
  <p>{{ 'template.floorplanText' | translate }}</p>
  <span>{{ 'template.description' | translate }}</span>
  <div class="images-block">
    @for (floorPlan of floorPlanImages; track floorPlan) {
      <div class="block">
        @if (floorPlan?.imageSrc) {
          <div miq-bg-image class="add-new" bgClass="custom-publish-icon-condensed" [secureImage]="floorPlan"></div>
          @if (floorPlan?.floor_suite) {
            <div class="desc">
              <ng-container> {{ floorPlan.position + '. ' }} </ng-container>
              @if (floorPlan.floor_suite.floor_number) {
                {{ floorPlan.floor_suite.floor_number + 'F' }}
              }
              @if (floorPlan.floor_suite.suite_number) {
                | {{ floorPlan.floor_suite.suite_number }}
              }
            </div>
          }
          <div class="actions">
            <mat-icon class="edit" svgIcon="edit-icon" (click)="openDialog(floorPlan.id, 'edit')"></mat-icon>
            <mat-icon svgIcon="delete" (click)="deleteFloorPlan(floorPlan)"></mat-icon>
          </div>
        } @else {
          @if (floorPlan?.availabilityImages > 0) {
            <div class="add-new">
              <div class="selectImage" (click)="openDialog(floorPlan.id, 'add')">
                <mat-icon svgIcon="add-icon"></mat-icon>
                <span>{{ 'template.selectImage' | translate }}</span>
              </div>
            </div>
          } @else {
            <div class="add-new" (click)="navigate(floorPlan.id)">
              <span class="text">{{ 'template.noImageAvailable' | translate }}</span>
              <div class="upload">
                <mat-icon svgIcon="icon-upload" color="y-upload" class="mat-icon-upload"></mat-icon>
                <span>{{ 'template.addNew' | translate }}</span>
              </div>
            </div>
          }
          @if (floorPlan?.floor_suite) {
            <div class="block desc">
              {{ floorPlan.position + '. ' }}
              @if (floorPlan.floor_suite.floor_number) {
                {{ floorPlan.floor_suite.floor_number + 'F' }}
              }
              @if (floorPlan.floor_suite.suite_number) {
                | {{ floorPlan.floor_suite.suite_number }}
              }
            </div>
          }
        }
      </div>
    }
  </div>
</div>
